export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12025.80a90c9d.jpg";